import React from 'react';

import { useInView } from '../../hooks/useInView';
import type { GettingStarted } from './types';

import './GettingStartedSection.css';

type GettingStartedSectionProps = {
    data: GettingStarted;
};

export function GettingStartedSection({ data }: GettingStartedSectionProps) {
    const [ref, inView] = useInView<HTMLElement>();

    return (
        <section
            ref={ref}
            className={`programs-start faves-reveal-group${inView ? ' faves-reveal-group--in' : ''}`}
        >
            <div className="programs-start__head">
                <span className="programs-eyebrow faves-reveal">{data.eyebrow}</span>
                <h2
                    className="programs-start__heading faves-reveal"
                    style={{ '--reveal-delay': '120ms' } as React.CSSProperties}
                >
                    {data.heading}
                </h2>
            </div>
            <ol className="programs-start__steps">
                {data.steps.map((step, i) => (
                    <li
                        className="programs-start__step faves-reveal"
                        key={step.number}
                        style={{ '--reveal-delay': `${200 + i * 220}ms` } as React.CSSProperties}
                    >
                        <span className="programs-start__number">{step.number}</span>
                        <h3 className="programs-start__step-title">{step.title}</h3>
                        <p className="programs-start__step-desc">{step.description}</p>
                    </li>
                ))}
            </ol>
        </section>
    );
}
